import { useCallback } from 'react';
import { usePeopleManagementApi } from 'infrastructure/api';

type EmployeePositionSlotValidationResponse = Record<string, EmployeePositionSlotValidationResultDto>;

const VALIDATION_URL = '/contracts/position-slots/validation';
const CHANGE_POSITION_SLOT_VALIDATION_URL = '/contracts/change/position-slots/validation';

type EmployeePositionSlotData = {
  positionId: number;
  technologyId: string | null;
  secondaryTechnologyId: string | null;
  competencyLevel: string | null;
};

type EmployeePositionSlotContractData = {
  officeId: string;
  contractType: string;
};

export type EmployeePositionSlotChangeValidationRequest = {
  employeeAlias: string;
  positionSlotId: string;
  employeeData?: EmployeePositionSlotData | null;
  contractData?: EmployeePositionSlotContractData | null;
};

export type EmployeePositionSlotValidationResultDto = {
  position: string;
  errors: string[];
};

const usePositionSlotValidationService = () => {
  const { sendPostRequest } = usePeopleManagementApi();

  const validateEmployeePositionSlots = useCallback(
    async (employeeToPositionSlot: Record<string, string>): Promise<EmployeePositionSlotValidationResponse> => {
      const response = await sendPostRequest(VALIDATION_URL, employeeToPositionSlot);

      return response.json();
    },
    [sendPostRequest],
  );

  const validateEmployeePositionSlotChange = useCallback(
    async (request: EmployeePositionSlotChangeValidationRequest): Promise<EmployeePositionSlotValidationResultDto> => {
      const response = await sendPostRequest(CHANGE_POSITION_SLOT_VALIDATION_URL, request);

      return response.json();
    },
    [sendPostRequest],
  );

  return {
    validateEmployeePositionSlots,
    validateEmployeePositionSlotChange,
  };
};

export default usePositionSlotValidationService;
